<template>
  <div class="header flex center gaps">
    <!-- Tab -->
    <div class="tabs box grow">
      <!-- Tab > Label -->
      <div class="orderConditionLabels">
        <p
          :style="{
            'padding-right': tabLabelPadding
          }"
        >
          注文前
        </p>
        <p>注文済み</p>
      </div>

      <!-- Tab > Items -->
      <el-tabs
        v-if="isOrderStatusLoaded"
        class="tabs_menu"
        v-model="localStatus"
        @tab-click="handleClick"
      >
        <!-- 注文前 -->
        <el-tab-pane
          name="DRAFT"
        >
          <div slot="label">
            下書き
            <span class="orderCountColor">{{ draftCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          class="border"
          name="ORDER_REQUEST"
        >
          <div slot="label">
            承認待ち
            <span class="orderCountColor">{{ orderRequestCounts }}</span>
          </div>
        </el-tab-pane>

        <!-- 分割 -->
        <el-tab-pane
          label="|"
          name="divide1"
          disabled
        />

        <!-- 注文済み -->
        <el-tab-pane
          label="すべて"
          name="ALL"
        />
        <el-tab-pane
          name="PROCESSING"
        >
          <div slot="label">
            新規注文
            <span class="orderCountColor">{{ processingCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="PROCESSING_CREATING_LAYOUT"
        >
          <div slot="label">
            レイアウト作成中
            <span class="orderCountColor">{{ processingCreatingLayoutCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="REVISING_LAYOUT"
        >
          <div slot="label">
            レイアウト調整
            <span class="orderCountColor">{{ revisingLayoutCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="CONFIRMED"
        >
          <div slot="label">
            注文確定
            <span class="orderCountColor">{{ confirmedCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="発送済み"
          name="SHIPPED"
        />
      </el-tabs>
    </div>

    <!-- Create order -->
    <div class="box">
      <el-button
        class="createButton"
        type="primary"
        :circle="!isLandscape"
        @click="onClickCreateOrder"
      >
        <i class="el-icon-plus" />
        {{ isLandscape ? "新規注文作成"  : "" }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  props: {
    status: String,
    orderCountByStatus: Object,
  },
  data () {
    return {
      isLoading: false,
      isLandscape: true,
      tabLabelPadding: "0px",
    };
  },
  computed: {
    localStatus: {
      get () {
        return this.status;
      },
      set (value) {
        this.$emit("update:status", value);
      },
    },
    isOrderStatusLoaded () {
      return Object.keys(this.orderCountByStatus).length !== 0;
    },
    draftCounts () {
      const orderCounts = this.orderCountByStatus["DRAFT"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    orderRequestCounts () {
      const orderCounts = this.orderCountByStatus["ORDER_REQUEST"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    processingCounts () {
      const orderCounts = this.orderCountByStatus["PROCESSING"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    processingCreatingLayoutCounts () {
      const orderCounts = this.orderCountByStatus["PROCESSING_CREATING_LAYOUT"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    revisingLayoutCounts () {
      const orderCounts = this.orderCountByStatus["REVISING_LAYOUT"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    confirmedCounts () {
      const orderCounts = this.orderCountByStatus["CONFIRMED"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
  },
  watch: {
    isOrderStatusLoaded () {
      this.setTabPadding();
    },
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    /**
     * [handleClick description]
     * @param   {[type]}  tab  [tab description]
     * @return  {[type]}       [return description]
     */
    handleClick (tab) {
      this.$emit("onChangeStatus");
    },

    /**
     * [onResize description]
     */
    onResize () {
      this.isLandscape = window.innerWidth > 820;
      this.setTabPadding();
    },

    /**
     * [onClickCreateOrder description]
     */
    onClickCreateOrder () {
      const isCreateOrder = true;

      this.$emit("keepHomeState", 0, isCreateOrder);
      this.$store.commit("orderForm/init");
      this.$router.push("/orders/create/step1");
    },
    setTabPadding () {
      if (this.isOrderStatusLoaded) {
        this.$nextTick(() => {
          // IDs of el-tab-pane
          const tabIds = ["tab-DRAFT", "tab-ORDER_REQUEST", "pane-divide1"];
          let totalWidth = 0;
          tabIds.forEach(tabId => {
            const tabElm = document.getElementById(tabId);
            const tabW = tabElm.clientWidth;
            totalWidth += tabW;
          });
          this.tabLabelPadding = `${totalWidth}px`;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.header {
  width: 100%;
  padding: 15px 18px;
  box-sizing: border-box;

  .orderCountColor {
    color: $--color-primary;
    letter-spacing: -1px;
  }
}

::v-deep {
  .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__item {
    padding: 0 10px;
    font-weight: bold;
  }

  .el-tabs__active-bar {
    height: 2px;
  }

  // 注文前と注文済みの分割用
  #tab-divide1.el-tabs__item {
    padding: 0 10px;
  }
}

.orderConditionLabels {
  display: flex;
  font-size: 12.5px;

  p {
    margin: 0;
    // padding-right: 209px;
  }
}

@media screen and (max-width: 820px) {
  .createButton {
    transform: scale(1.125);
    transform-origin: 80% 50%;

    .el-icon-plus {
      margin-right: 0px;
    }
  }
}

@media screen and (min-width: 821px) {
  .createButton {
    .el-icon-plus {
      margin-right: 10px;
    }
  }
}
</style>
